import { Expertise } from '@sortlist-frontend/data-fetching/core-types';
import { ReactNode } from 'react';

import { useSharedComponentsContext } from '../utils';
import { useGetExpertisesCategories } from './useGetExpertiseCategories';

type CategoryExpertises = {
  type: string;
  name: ReactNode;
  expertises: Partial<Expertise>[];
};

export const useGroupedExpertises = (allExpertises?: Partial<Expertise>[]) => {
  const { t } = useSharedComponentsContext();
  const expertisesCategories = useGetExpertisesCategories();

  if (allExpertises == null) return;

  const expertisesCategoriesWithOthers = { ...expertisesCategories, others: t('base:expertises.categories.others') };

  const groupedExpertises: Record<string, CategoryExpertises> = Object.keys(expertisesCategoriesWithOthers).reduce(
    (acc, key) => {
      acc[key] = {
        type: key,
        name: expertisesCategoriesWithOthers[key as keyof typeof expertisesCategoriesWithOthers],
        expertises: [],
      };
      return acc;
    },
    {} as Record<string, CategoryExpertises>,
  );

  allExpertises.forEach((expertise) => {
    const type = expertise.category as keyof typeof groupedExpertises;
    if (type == null) return;

    if (groupedExpertises[type] != null) {
      groupedExpertises[type].expertises.push(expertise);
    } else {
      groupedExpertises['others'].expertises.push(expertise);
    }
  });

  const groupedExpertisesList = Object.values(groupedExpertises);

  groupedExpertisesList.map((category) => {
    category.expertises.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
  });

  return groupedExpertisesList.filter((category) => category.expertises.length > 0);
};
